import Overview from '@rebuild/materials/shared/question/Overview.vue';
import Full from './full.vue';

export const componentMap = {
	overview: Overview,
	full: Full
};
